"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
var api_1 = require("./api");
var config_1 = __importStar(require("../config"));
var getRailById_1 = __importDefault(require("./queries/getRailById"));
var reselect_1 = require("reselect");
var fastMemoize_1 = __importDefault(require("./fastMemoize"));
exports.createRailsSelectors = function (namespace, reducer) {
    return {
        rails: reselect_1.createSelector(function (state) { var _a; return (_a = state[namespace].content.data) === null || _a === void 0 ? void 0 : _a.rails; }, function (r) {
            return r && (r === null || r === void 0 ? void 0 : r.filter(function (i) { return i; }).map(function (rail) {
                var _a, _b;
                return (__assign(__assign({}, rail), { contentPage: rail.contentPage
                        ? __assign(__assign({}, rail.contentPage), { content: (_b = (_a = rail.contentPage) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.filter(function (i) { return i; }) }) : null }));
            }));
        }),
        rail: reselect_1.createSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state === null || state === void 0 ? void 0 : state[namespace]) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.rails; }, function (data) { return fastMemoize_1.default(function (railId) { return data === null || data === void 0 ? void 0 : data.find(function (_a) {
            var id = _a.id;
            return id === railId;
        }); }); }),
        isLoading: reselect_1.createSelector(function (state) { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state[namespace]) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.isLoading; }, function (l) { return l; }),
        error: reselect_1.createSelector(function (state) { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state[namespace]) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.error; }, function (e) { return e; }),
        railsShallow: reselect_1.createSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state === null || state === void 0 ? void 0 : state[namespace]) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.rails; }, function (r) { return r && (r === null || r === void 0 ? void 0 : r.filter(function (i) { return i; }).map(function (i) { return i.id; })); }),
        continueWatchingRailId: reselect_1.createSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state === null || state === void 0 ? void 0 : state[namespace]) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.rails; }, function (data) { var _a; return (_a = data === null || data === void 0 ? void 0 : data.find(function (_a) {
            var __typename = _a.__typename;
            return __typename === 'ContinueWatchingGroup';
        })) === null || _a === void 0 ? void 0 : _a.id; }),
    };
};
exports.createFetchRailAction = function (actionType, railId, endCursor, sectionId, appId, deviceId, nextPageSize) {
    return api_1.createApiAction(actionType, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: getRailById_1.default(nextPageSize, endCursor),
            variables: { railId: railId, sectionId: sectionId, appId: appId, deviceId: deviceId },
        },
        meta: { railId: railId },
        authenticated: true,
        graphQL: true,
    });
};
exports.createRailReducer = function (actionType) {
    return api_1.createApiReducer({
        actionType: actionType,
        onRequest: function (draftState, action) {
            var _a;
            if (Array.isArray((_a = draftState.data) === null || _a === void 0 ? void 0 : _a.rails)) {
                draftState.data.rails.some(function (rail) {
                    if (rail.id === action.meta.railId) {
                        rail.isLoading = true;
                        return true;
                    }
                    return false;
                });
            }
        },
        onSuccess: function (draftState, action) {
            var _a;
            var groupRes = action.payload.experience.section.home.group;
            (_a = draftState.data.rails) === null || _a === void 0 ? void 0 : _a.some(function (rail) {
                var _a;
                var _b, _c, _d, _e;
                if (rail.id === action.meta.railId) {
                    rail.isLoading = false;
                    // Nullify the error state on a successful api response so that user can scroll more rails
                    // in subsequent attempts. Enhance when implementing https://skynz.atlassian.net/browse/SAAA-4881
                    rail.error = null;
                    rail.contentPage.pageInfo = (_b = groupRes === null || groupRes === void 0 ? void 0 : groupRes.contentPage) === null || _b === void 0 ? void 0 : _b.pageInfo;
                    if (Array.isArray((_c = groupRes === null || groupRes === void 0 ? void 0 : groupRes.contentPage) === null || _c === void 0 ? void 0 : _c.content)) {
                        rail.contentPage.content = ((_d = rail === null || rail === void 0 ? void 0 : rail.contentPage) === null || _d === void 0 ? void 0 : _d.content) || [];
                        (_a = rail.contentPage.content).push.apply(_a, (_e = groupRes === null || groupRes === void 0 ? void 0 : groupRes.contentPage) === null || _e === void 0 ? void 0 : _e.content);
                    }
                    return true;
                }
                return false;
            });
        },
        onFailure: function (draftState, action) {
            var _a;
            (_a = draftState.data.rails) === null || _a === void 0 ? void 0 : _a.some(function (rail) {
                if (rail.id === action.meta.railId) {
                    rail.isLoading = false;
                    // UPDATE: due to implementation on native-app error somehow should be set to null after a shot pause
                    // as there is no way for user to do it by scrolling back like in WEB
                    rail.error = action.payload;
                    return true;
                }
                return false;
            });
        },
    });
};
//# sourceMappingURL=Rails.js.map